module.exports = __webpack_public_path__ + "static/media/ic_map.411ec41f.svg";